import { useContext } from 'react';
import { DashboardContext } from '../../contexts/DashboardContext';
import { DashboardContextData } from '../../types';

export const useDashboard = (): DashboardContextData =>
  useContext(DashboardContext);
